/* eslint-disable max-len */
export default {
    title: {
        threats: 'Dowiedz się jak możesz zabezpieczyć swoje dane.',
        offer: 'Dowiedz się jakie narzędzia zapewnią Ci kompleksowe bezpieczeństwo.',
        minimize: 'Czy chcesz zminimalizować ryzyko cyberataków w Twojej organizacji?',
        estimate: 'Czy chcesz zwiększyć bezpieczeństwo swoich aplikacji? ',
        breach: 'Czy jesteś ofiarą cyberataku?',
        // risk: 'Czy chcesz przygotować swoją organizację do zgodności z RODO?',
        audit: 'Czy chcesz, aby Twoja aplikacja/system informatyczny były zgodne z RODO?',
        bottom: 'Interesuje Cię kompleksowe rozwiązanie związane z bezpieczeństwem zasobów i gromadzonych przez Ciebie danych?',
        contact: 'Jak najszybciej skontaktuj się z nami!'
    },
    placeholder: {
        email: 'Twój firmowy email',
        phone: 'Telefon'
    },
    button: {
        offer: 'Umów się na konsultacje',
        consultation: 'Umów bezpłatną konsultację',
        breach: 'Sprawdź, jakie kroki musisz podjąć po incydencie',
        refresh: 'Odśwież'
        // risk: 'Uzyskaj analizę ryzyka'
    },
    message: {
        general_error: 'Proszę wypełnić prawidłowo wszystkie pola.',
        domain_error: 'Nie akceptujemy tymczasowych adresów email. Podaj poprawny adres email',
        recaptcha_error: 'Coś poszło nie tak, proszę wcisnąć przycisk odśwież i spróbować ponownie.',
        server_error: 'Tymczasowy bład serwera. Umów rozmowę wysyłając wiadomość na contact@lemlock.com',
        success: 'Wiadomość została wysłana'
    },
    link: {
        breach: 'https://www.lemlock.com/procedury-reagowania-na-cyberataki/'
    }
};



// WEBPACK FOOTER //
// ./src/i18n/pl/form.js